module.exports = __webpack_public_path__ + "static/fast-card-basic-63748368e96e4ae9bf0dd0e5b972d4a7.png";